import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

import { PortalPaths } from './paths';
import {Language} from './language';
import { LanguageService } from './language.service';
import { ButtonBehaviourTypesEnum, ButtonTypesEnum } from './enums';
import { Helper } from './classes/helpers/helper';

export const ErrorMessageIdSelector = 'id';

export class BaseComponent {
  protected subscriptionsArray: Subscription[];

  public selectedLanguage: string;
  public readonly languages: typeof Language = Language;
  public readonly appPaths: typeof PortalPaths;
  public readonly buttonTypesEnum: typeof ButtonTypesEnum;
  public readonly buttonBehaviourTypesEnum: typeof ButtonBehaviourTypesEnum;
  public readonly dateFormat: string;
  public readonly dateAndTimeFormat: string;
  public readonly dateShortFormat: string;

  protected constructor(
    protected languageService: LanguageService,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
  ) {
    this.subscriptionsArray = [];
    this.appPaths = PortalPaths;
    this.buttonTypesEnum = ButtonTypesEnum;
    this.buttonBehaviourTypesEnum = ButtonBehaviourTypesEnum;
    this.selectedLanguage = languageService.getCurrentLanguage();
    this.dateFormat = Helper.datesHelper().getViewDateFormat(this.selectedLanguage);
    this.dateShortFormat = Helper.datesHelper().getShortDateFormat();
    this.dateAndTimeFormat = Helper.datesHelper().getDateAndTimeFormat();

	Helper.initializeGoogleTagManager();
  }

  protected navigateToErrorPage(status: number, messages?: string[]): void {
    const timestamp = moment().unix();

    this.router.navigate([`/${this.languageService.getCurrentLanguage()}/error`], {
      queryParams: {
        [ErrorMessageIdSelector]: timestamp
      }
    }).finally();
  }

  onDestroy(): void {
    this.subscriptionsArray
      .forEach(subscription => subscription && subscription.unsubscribe());
  }

  changeLanguage(language: string, forceRedirect = false): void {
    const url = this.router.routerState.snapshot.url;
    const queryParams = this.activatedRoute.snapshot.queryParamMap;
    const redirectKey = 'forceRedirect';

    const path = url
      .slice(3)
      .split('?')[0]
      .split('#')[0];

    this.selectedLanguage = language;

    let redirectPath = `/${language}${path}`;

    const params = [];

    queryParams.keys.forEach(key => {
      if (key !== redirectKey) {
        params.push({ key, value: queryParams.get(key) });
      }
    });

    if (forceRedirect) {
      params.push({ key: redirectKey, value: true });
    }

    if (params.length > 0) {
      redirectPath += '?';

      params.forEach(param => {
        redirectPath += `&${param.key}=${param.value}`;
      });
    }

    window.location.href = redirectPath;
  }

  isBulgarian(): boolean {
    return this.selectedLanguage === Language.Bulgarian;
  }

  isEnglish(): boolean {
    return this.selectedLanguage === Language.English;
  }

  getLocalizedClassList(): { [key: string]: boolean } {
    return { bg: this.isBulgarian(), en: this.isEnglish() };
  }
}
